import { QueryAPI } from "../api";
import { delay } from "../tools";

export const useAPIPublic = () => {
	//لاگین به سرویس
	const login = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/Login", parameters: parameters });
		return response ? response.Result : null;
	};
	//دریافت توکن
	const createApiTokenBySession = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/CreateAPITokenBySession", parameters: parameters });
		return response ? response?.Result : null;
	};
	//دریافت درصد مالیات
	const queryTaxPercent = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryTaxPercent", type: "GET" });
		return response ? response.Result : null;
	};
	//دریافت توکن برای دسترسی به کیف پول
	const accessAsanWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/AccessAsanWallet", parameters: parameters });
		return response ? response?.Result : null;
	};
	//ارسال کد OTP
	const sendOTPCodeAsync = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/SendOTPCodeAsync", parameters: parameters });
		return response ? response?.Result : null;
	};
	//ارسال مجدد کد OTP
	const resendOTPCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/ResendOTPCode", parameters: parameters });
		return response ? response?.Result : null;
	};
	//تایید کد OTP
	const confirmOTPCode = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/ConfirmOTPCode", parameters: parameters });
		return response ? response : null;
	};
	//دریافت اطلاعات مربوط به کاربر
	const queryCurrentUser = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryCurrentUser", type: "Get" });
		return response ? response?.Result : null;
	};

	const queryMSISDNStatus = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryMSISDNStatus", type: "Get" });
		return response ? response?.Result : null;
	};

	//جنسیت
	const queryGender = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryGender", type: "GET" });
		return response ? response.Result : null;
	};
	//لیست استان ها
	const queryActiveProvince = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveProvince", type: "GET" });
		return response ? response.Result : null;
	};
	// دریافت اطلاعات استان و شهر
	const queryCityByCityId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryCityByCityId?cityid=" + parameters, type: "GET" });
		return response ? response.Result : null;
	};
	//لیست شهر ها براساس استان
	const queryActiveCityByProvinceId = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveCityByProvinceId?provinceid=" + parameters, type: "GET" });
		return response ? response.Result : null;
	};
	//resetPassword
	const resetPassword = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/resetPassword", parameters: parameters });
		return response ? response : null;
	};

	//بارگذاری فایل
	const addDocument = async (request, queryString) => {
		let response = null;
		response = await QueryAPI({
			url: `/public/Document/AddDocument?doctype=${queryString}`,
			parameters: request,
			contentType: "multipart/form-data",
		});
		await delay();
		return response ? response : null;
	};
	//دریافت فایل بارگذاری شده
	const getDocument = async (request) => {
		let response = null;
		response = await QueryAPI({ url: `/public/Document/GetDocument?docid=${request}`, type: "GET" });
		return response ? response.Result : null;
	};
	//دریافت لیست کیف پول
	const queryWalletType = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryWalletType", type: "Get" });
		return response ? response.Result : null;
	};

	//ارسال OTP
	const queryOTPIsRequired = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryOTPIsRequired", parameters: parameters });
		return response ? response.Result : null;
	};

	//دریافت دلایل تعویض سیم کارت
	const querySimSwapReason = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QuerySimSwapReason", type: "GET" });
		return response ? response.Result : null;
	};

	//دریافت لیست مدارک
	const queryCertType = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryCertType", type: "GET" });
		return response ? response.Result : null;
	};

	//دریاف لیست کشورها
	const queryActiveCountry = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveCountry", type: "GET" });
		return response ? response.Result : null;
	};

	//دریافت زبان
	const queryActiveLanguage = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryActiveLanguage", type: "GET" });
		return response ? response.Result : null;
	};

	//دریافت حداقل برداشت
	const queryMinimumAmountGetCashFromWallet = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryMinimumAmountGetCashFromWallet", type: "GET" });
		return response ? response.Result : null;
	};

	const queryPayredJobs = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryPayredJobs", type: "GET" });
		return response ? response.Result : null;
	};

	//برداشت از اعتبار
	const withdrawUserWallet = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/WithdrawUserWallet", parameters: parameters });
		return response ? response.Result : null;
	};

	//رفرش توکن
	const refreshToken = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/RefreshToken", parameters: parameters });
		return response ? response.Result : null;
	};
	//بروزرسانی کلمه عبور
	const updateUserPassword = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/UpdateUserPassword", parameters: parameters });
		return response ? response.Result : null;
	};

	//دریافت نقش کاربر
	const queryUserRoles = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/Security/QueryUserRoles", type: "GET" });
		return response ? response.Result : null;
	};

	const queryOperators = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryOperators", type: "GET" });
		return response ? response : null;
	};

	const queryPoolType = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryPoolType", type: "GET" });
		return response ? response.Result : null;
	};

	const queryICCIDRequestStatus = async () => {
		let response = null;
		response = await QueryAPI({ url: "/public/BaseInfo/QueryICCIDRequestStatus", type: "GET" });
		return response ? response.Result : null;
	};

	return {
		createApiTokenBySession,
		login,
		queryTaxPercent,
		accessAsanWallet,
		sendOTPCodeAsync,
		resendOTPCode,
		confirmOTPCode,
		queryCurrentUser,
		resetPassword,
		queryGender,
		queryActiveProvince,
		queryCityByCityId,
		queryActiveCityByProvinceId,
		addDocument,
		queryWalletType,
		queryOTPIsRequired,
		querySimSwapReason,
		queryCertType,
		queryActiveCountry,
		queryActiveLanguage,
		getDocument,
		queryMinimumAmountGetCashFromWallet,
		queryPayredJobs,
		withdrawUserWallet,
		refreshToken,
		updateUserPassword,
		queryUserRoles,
		queryMSISDNStatus,
		queryOperators,
		queryPoolType,
		queryICCIDRequestStatus,
	};
};
